import { PromoCodePermissions } from "../../Component/Permissions/PermissionsInterface.";
// Interface for PromoCode data
export interface IPromoCode {
    promo_code_id: string;
    promo_code: string;
    amount: string;
    minTransactionAmt?: string;
    is_active: number;
    is_used: number;
    influence_name: string;
    influence_id: number;
    createdDate: string;
    startTime: string;  
    endTime: string; 
    applicableFirstTransaction: number;
    usedCount:number
}

export interface ICashBackCoupon {
    cashbackCouponId: string;
    coupon_code: string;
    amount: string;
    minTransactionAmt: string;
    isActive: number;
    isUsed: number;
    isExpired: number;
    transactionId: string | null;
    startTime: string;  
    endTime: string;   
    createdDate: string; 
    stripeTransactionId: string;
}

// Interface for PromoCodes component state
export interface PromoCodesState {
    accessToken: string;
    promoCodeList: IPromoCode[];
    cashbackCouponList: ICashBackCoupon[]
    currentRowsPerPage: number;
    currentPage: number;
    totalRows: number;
    searchText: string;
    filterValue: string;
    selectedKey: String;
    userID: string;
    isOpenAddPromoCodeDialog: boolean;
    isOpenAddCashbackCouponDialog:boolean;
    promoCode: PromoCodePermissions;
    selectedTab: number;
    paginationReset: boolean;
    isOpenEditDetailsDialog: boolean;
    selectedPromoCode: IPromoCode | null;
    selectedCouponCode: ICashBackCoupon | null;
    isOpenViewDetailsDialog: boolean;
}

export enum SelectedTab {
    PROMO_CODE = 0,
    CASHBACK_COUPON = 1,
}

//Interface for PromoCodes component props
export interface PromoCodesProps {

}